const state = {
  loading: false,
  token: localStorage.getItem('Token'),
  btnsList: [],
  tabs: [],
  tabsValue: '',
  role: {},
  isUploadImgEnd: false,
}

const getters = {
  s_loading(state) {
    return state.loading
  },
  s_token(state) {
    return state.token
  },
  s_btnsList(state) {
    return state.btnsList
  },
  s_tabs(state) {
    return state.tabs
  },
  s_tabsValue(state) {
    return state.tabsValue
  },
  s_role(state) {
    return state.role
  },
  s_isUploadImgEnd(state) {
    return state.isUploadImgEnd
  }
}

const mutations = {
  SET_LOADING: (state, flag) => {
    state.loading = flag
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_BTNSLIST: (state, btnsList) => {
    state.btnsList = btnsList
  },
  SET_TABS: (state, tabs) => {
    state.tabs = tabs
  },
  SET_TABSVALUE: (state, tabsValue) => {
    state.tabsValue = tabsValue
  },
  SET_ROLE: (state, role) => {
    state.role = role
  },
  SET_ISUPLOADIMGEND: (state, isUploadImgEnd) => {
    state.isUploadImgEnd = isUploadImgEnd
  },
}

const actions = {
  setLoading({commit}, flag) {
    commit('SET_LOADING', flag)
  },
  setToken({commit}, token) {
    commit('SET_TOKEN', token)
  },
  setBtnsList({commit}, btnsList) {
    commit('SET_BTNSLIST', btnsList)
  },
  setTabs({commit}, tabs) {
    commit('SET_TABS', tabs)
  },
  setTabsValue({commit}, tabsValue) {
    commit('SET_TABSVALUE', tabsValue)
  },
  setRole({commit}, role) {
    commit('SET_ROLE', role)
  },
  setIsUploadImgEnd({commit}, isUploadImgEnd) {
    commit('SET_ISUPLOADIMGEND', isUploadImgEnd)
  },
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
